import $ from 'jquery';
import EventDispatcher from 'components/csrFactoryMap/utils/EventDispatcher';
import { gsap, Power2, CSSPlugin } from 'gsap/all';

gsap.registerPlugin(Power2, CSSPlugin);
export default class CSRFactoryMap extends EventDispatcher {
  constructor(options) {
    super(options);
    this.el = options.el;
    this.$el = $(this.el);

    this.initialize();
  }

  initialize() {
    this.cacheSelectors();
    this.setupEventListeners();
  }

  toggleState(isShow) {
    let tl;
    if (isShow) {
      // this.el.removeAttribute('style');
      tl = gsap.timeline();
      tl.to(this.el, 0.5, { x: 0, ease: Power2.easeInOut });
      tl.staggerFromTo(
        this.ui.legendButtons,
        0.4,
        { x: -5, opacity: 0 },
        { x: 0, opacity: 1 },
        0.04
      );
    } else {
      tl = gsap.timeline();
      tl.to(this.el, 0.3, { x: -90, ease: Power2.easeInOut });

      // this.el.style.display = 'none';
    }
  }

  clearActiveFilterButton() {
    if (this.button) {
      this.button.classList.remove('is-selected');
      this.button = null;
    }
  }

  cacheSelectors() {
    this.ui = {
      legendButtons: this.el.querySelectorAll('.js-legend-button'),
    };
  }

  setupEventListeners() {
    this.$el.on('click', '.js-legend-button', e => this.onLegendClicked(e));
  }

  onLegendClicked(e) {
    if (this.button === e.currentTarget) {
      this.clearActiveFilterButton();
      this.trigger('csrmap:legend:select', { productId: null });
    } else {
      this.clearActiveFilterButton();
      this.button = e.currentTarget;
      this.button.classList.add('is-selected');
      this.trigger('csrmap:legend:select', { productId: this.button.dataset.product });
    }
  }
}
